<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LinkedButton',
  props: {
    link: { type: String, required: true },
    text: { type: String, required: true },
    classNames: { type: String },
    type: { type: String, default: 'primary' },
    mdiIcon: { type: String },
    iconSize: { type: Number, default: 24 },
    fontSize: { type: Number, default: 16 },
  },
  computed: {
    styles() {
      let bg: string;
      let border: string;
      let fontColor: string;

      switch (this.type) {
        case 'primary':
          bg = '#4E8EB1';
          border = '#4E8EB1';
          fontColor = '#ffffff';
          break;
        case 'secondary':
          bg = '#f5f5f5';
          border = '#111111';
          fontColor = '#111111';
          break;
        default:
          bg = '#EFEFEF';
          border = '#111111';
          fontColor = '#111111';
          break;
      }

      return {
        backgroundColor: bg,
        border: `1px solid ${border}`,
        color: fontColor,
        fontSize: `${this.fontSize}px`,
        borderRadius: '6px',
        padding: '4px 8px',
      };
    },
  },
});
</script>

<template>
  <router-link
      :to="{ path: link }"
      :class="classNames"
      @click="$emit('onClick')"
      :style="styles"
      custom
      v-slot="{ navigate }"
  >
    <button @click="navigate" :style="styles" :class="classNames">
      <div class="flex items-center">
        <v-icon :color="styles.color" v-if="mdiIcon" :size="iconSize">{{ mdiIcon }}</v-icon>
        <span class="ml-1">{{ text }}</span>
      </div>
    </button>
  </router-link>
</template>

<style scoped>

</style>
